import type { CmsArea } from '@/components/CmsInterfaces';
import { DynamicComponent } from '@/components/DynamicComponent';

export default function Area(props: CmsArea) {
  return props.nodes ? (
    <>{props.nodes.map((node) => DynamicComponent(node))}</>
  ) : null;
}
